import { Component, OnInit, inject } from '@angular/core';
import { DrawerService } from '../../../ui/drawer/drawer.service';
import { DRAWER_DATA } from '../../../ui/drawer/drawer-data.token';
import { BusinessFile } from '@models/businesses/businesses';

@Component({
	selector: 'app-logo-drawer',
	templateUrl: './logo-drawer.component.html',
	standalone: false,
})
export class LogoDrawerComponent implements OnInit {
	public logoFile: BusinessFile;
	private drawerService = inject(DrawerService);
	private data: { logoFile: BusinessFile } = inject(DRAWER_DATA);

	ngOnInit(): void {
		this.logoFile = this.data.logoFile;
	}
}
